var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import env from 'config/env';
import moment from 'moment';
import { MediaAsset } from 'packages/media/MediaAsset';
import { AdAccount } from 'packages/target/entities/AdAccount';
import { EstimatedReachRange } from 'packages/target/entities/EstimatedReachRange';
import { TargetingOptions } from 'packages/target/entities/TargetingOptions';
export var CAMPAIGN_STATUSES = {
    NEW: 'new',
    QUEUED: 'queued',
    ENDED: 'ended',
};
var Campaign = /** @class */ (function (_super) {
    __extends(Campaign, _super);
    function Campaign() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.jobId = null;
        _this.intro = null;
        _this.title = null;
        _this.description = null;
        _this.budget = null;
        _this.status = null;
        _this.startsAt = null;
        _this.endsAt = null;
        _this.url = null;
        _this.facebookUrl = null;
        _this.publishedAt = null;
        _this.adAccount = null;
        _this.image = null;
        _this.targetingOptions = new TargetingOptions();
        _this.estimatedReachRange = null;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Campaign.prototype.toJson = function (toSnake, asString) {
        var json = _super.prototype.toJson.call(this, toSnake, asString);
        json.account_id = this.adAccount.id;
        delete json.facebook_ad_account;
        return json;
    };
    Campaign.prototype.formattedDateRange = function (i18n) {
        // Adding +1 after the moment.diff() because campaigns always end at 23.59, so we'll need to add plus one to represent reality
        var formattedDateRange = moment(this.endsAt).isAfter(this.startsAt, 'year')
            ? moment(this.startsAt).format('DD.MM.YYYY') + " - " + moment(this.endsAt).format('DD.MM.YYYY')
            : moment(this.startsAt).format('DD.MM') + " - " + moment(this.endsAt).format('DD.MM.YYYY');
        return formattedDateRange + " (" + (moment(this.endsAt).diff(this.startsAt, 'days') + 1) + " " + i18n.t('target.campaigns.summary.days') + ")";
    };
    Object.defineProperty(Campaign.prototype, "isActive", {
        get: function () {
            var now = moment();
            return moment(this.startsAt).startOf('day').isBefore(now)
                && moment(this.endsAt).endOf('day').isAfter(now)
                && this.status !== CAMPAIGN_STATUSES.ENDED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Campaign.prototype, "isPublished", {
        get: function () {
            return this.publishedAt !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Campaign.prototype, "isScheduled", {
        get: function () {
            return moment(this.startsAt).startOf('day').isAfter(moment())
                && this.status !== CAMPAIGN_STATUSES.ENDED;
        },
        enumerable: false,
        configurable: true
    });
    Campaign.generateUrlFromForm = function (form) {
        if (!form) {
            return null;
        }
        return env.APPS.FORM_VIEWER.URL + form.uuid;
    };
    var _a, _b;
    __decorate([
        Type(AdAccount),
        __metadata("design:type", typeof (_a = typeof AdAccount !== "undefined" && AdAccount) === "function" ? _a : Object)
    ], Campaign.prototype, "adAccount", void 0);
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", Object)
    ], Campaign.prototype, "image", void 0);
    __decorate([
        Type(TargetingOptions),
        __metadata("design:type", Object)
    ], Campaign.prototype, "targetingOptions", void 0);
    __decorate([
        Type(EstimatedReachRange),
        __metadata("design:type", typeof (_b = typeof EstimatedReachRange !== "undefined" && EstimatedReachRange) === "function" ? _b : Object)
    ], Campaign.prototype, "estimatedReachRange", void 0);
    return Campaign;
}(Entity));
export { Campaign };
